import { render, staticRenderFns } from "./TopMenuItem.vue?vue&type=template&id=4109c692"
import script from "./TopMenuItem.vue?vue&type=script&lang=js"
export * from "./TopMenuItem.vue?vue&type=script&lang=js"
import style0 from "./TopMenuItem.vue?vue&type=style&index=0&id=4109c692&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports